import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseHighchartComponent } from './components/base-highchart/base-highchart.component';
import { BarsChartComponent } from './components/cards/bars-chart/bars-chart.component';
import { LineChartComponent } from './components/cards/line-chart/line-chart.component';
import { DonutChartComponent } from './components/cards/donut-chart/donut-chart.component';
import { SalesBreakdownComponent } from './components/cards/sales-breakdown/sales-breakdown.component';
import { StatisticsBreakdownComponent } from './components/cards/statistics-breakdown/statistics-breakdown.component';
import { AgentStatusTimeComponent } from './components/cards/agent-status-time/agent-status-time.component';
import { MessageTrafficComponent } from './components/cards/message-traffic/message-traffic.component';
import { BugReportComponent } from './components/bug-report/bug-report.component';
import { HourlySalesComponent } from './components/cards/hourly-sales/hourly-sales.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CallResolvedComponent } from './components/cards/call-resolved/call-resolved/call-resolved.component';
import { EfficiencyCallStatsComponent } from './components/cards/efficiency-call-stats/efficiency-call-stats/efficiency-call-stats.component';
import { PeakHourTrafficComponent } from './components/cards/peak-hour-traffic/peak-hour-traffic/peak-hour-traffic.component';
import { ConnectedCallStatisticsComponent } from './components/cards/connected-call-statistics/connected-call-statistics.component';
import { NotConnectedCallStatisticsComponent } from './components/cards/not-connected-call-statistics/not-connected-call-statistics.component';
import { AbandonedCallStatisticsComponent } from './components/cards/abandoned-call-statistics/abandoned-call-statistics.component';
import { AgentsViewComponent } from './components/cards/agents-view/agents-view.component';
import { TopDispositionsComponent } from './components/cards/top-dispositions/top-dispositions.component';
import { ChatVolumeComponent } from './components/cards/chat-volume/chat-volume.component';
import { ChatBreakdownComponent } from './components/cards/chat-breakdown/chat-breakdown.component';
import { ChatStatisticsComponent } from './components/cards/chat-statistics/chat-statistics.component';
import { ChatChannelStatsComponent } from './components/cards/chat-channel-stats/chat-channel-stats.component';
import { PasswordStrengthMeterModule } from './components/password-strength-meter/password-strength-meter.module';
import { CampaignMonitorCallsComponent } from './components/cards/campaign-monitor-calls/campaign-monitor-calls.component';
import { AgentStatusTimeVerticalComponent } from './components/cards/agent-status-time-vertical/agent-status-time-vertical.component';
import { CampaignMonitorSalesComponent } from './components/cards/campaign-monitor-sales/campaign-monitor-sales.component';
import { ToggleOptionsComponent } from '../../components/toggle-options/toggle-options.component';
import { HourlyCallsAndSalesComponent } from './components/cards/hourly-calls-and-sales/hourly-calls-and-sales.component';
import { DropdownModule } from '../dropdown/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SurveysComponent } from './components/cards/surveys/surveys.component';
import { ChannelTrackComponent } from './components/cards/chat-channel-track/channel-track/channel-track.component';
import { AverageChatComponent } from './components/cards/average-chat/average-chat.component';
import { AverageRatingComponent } from './components/cards/average-rating/average-rating.component';
import { ChatBreakdownV2Component } from './components/cards/chat-breakdown-v2/chat-breakdown-v2.component';
import { SmsBreakdownComponent } from './components/cards/sms-breakdown/sms-breakdown.component';
import { VocSentimentCountComponent } from './components/cards/voc-sentiment-count/voc-sentiment-count.component';
import { VocSentimentTrendComponent } from './components/cards/voc-sentiment-trend/voc-sentiment-trend.component';
import { VocCategorySummaryComponent } from './components/cards/voc-category-summary/voc-category-summary.component';
import { VocTrendingTopicsComponent } from './components/cards/voc-trending-topics/voc-trending-topics.component';
import { VocTrendingWordsComponent } from './components/cards/voc-trending-words/voc-trending-words.component';
import { VocCategoriesDisplayedOverTimeComponent } from './components/cards/voc-categories-displayed-over-time/voc-categories-displayed-over-time.component';
import { VocTopVisitedSitesComponent } from './components/cards/voc-top-visited-sites/voc-top-visited-sites.component';
import { VocTopRatedSitesComponent } from './components/cards/voc-top-rated-sites/voc-top-rated-sites.component';
import { VocRatingDistributionsTsComponent } from './components/cards/voc-rating-distributions.ts/voc-rating-distributions.ts.component';
import { VocReviewsComponent } from './components/cards/voc-reviews/voc-reviews.component';
import { CallSaleStatsHourlyComponent } from './components/cards/call-sale-stats-hourly/call-sale-stats-hourly.component';
import { LeadsCallStatisticsComponent } from './components/cards/leads-call-statistics/leads-call-statistics.component';
import { LeadStatusStatisticsComponent } from './components/cards/lead-status-statistics/lead-status-statistics.component';
import { LeadConversionRatioComponent } from './components/cards/lead-conversion-ratio/lead-conversion-ratio.component';
import { OutboundDialerComponent } from './components/cards/outbound-dialer/outbound-dialer.component';
import { CardAvgCallPickupRateComponent } from './components/cards/card-avg-call-pickup-rate/card-avg-call-pickup-rate.component';
import { UnContactedLeadsComponent } from './components/cards/un-contacted-leads/un-contacted-leads.component';
import { NumberOfLeadsDialedComponent } from './components/cards/number-of-leads-dialed/number-of-leads-dialed.component';
import { NumberOfContactImportComponent } from './components/cards/number-of-contact-import/number-of-contact-import.component';
import { OutboundCampaignProgressComponent } from './components/cards/outbound-campaign-progress/outbound-campaign-progress.component';
import { TopFiveFailConversionsComponent } from './components/cards/top-five-fail-conversions/top-five-fail-conversions.component';
import { SuccessCallRateComponent } from './components/cards/success-call-rate/success-call-rate.component';
import { ConversionFirstAttemptComponent } from './components/cards/conversion-first-attempt/conversion-first-attempt.component';
import { RequestsComponent } from './components/request/requests.component';

import { AgentDispositionsWithLeadsPerDayComponent } from './components/cards/agent-dispositions-with-leads-per-day/agent-dispositions-with-leads-per-day.component';
import { SaleByProviderComponent } from './components/cards/sale-by-provider/sale-by-provider.component';
import { LeadSummaryComponent } from './components/cards/lead-summary/lead-summary.component';
import { LeadsDialedMadeComponent } from './components/cards/leads-dialed-made/leads-dialed-made.component';
import { LeadsConnectedCallsComponent } from './components/cards/leads-connected-calls/leads-connected-calls.component';
import { LeadsEmailSendComponent } from './components/cards/leads-email-send/leads-email-send.component';
import { LeadsCadenceComponent } from './components/cards/leads-cadence/leads-cadence.component';
import { LeadsDispositionsComponent } from './components/cards/leads-dispositions/leads-dispositions.component';
import { StarlinkStatsComponent } from './components/cards/starlink-stats/starlink-stats.component';
import { LeadsCountryWiseDistributionComponent } from './components/cards/leads-country-wise-distribution/leads-country-wise-distribution.component';
import { LeadsResolvedComponent } from './components/cards/leads-resolved/leads-resolved.component';
import { GaugeClockComponent } from '../gauge-clock/gauge-clock.component';
import { SkillWiseHourlyComponent } from './components/cards/skill-wise-hourly/skill-wise-hourly.component';
import { SkillWiseSummaryComponent } from './components/cards/skill-wise-summary/skill-wise-summary.component';
import { StarlinkAgentLeadCountryWiseComponent } from './components/cards/starlink-agent-lead-country-wise/starlink-agent-lead-country-wise.component';
import { SkillWiseHourlyHeatMapComponent } from './components/cards/skill-wise-hourly-heatmap/skill-wise-hourly-heatmap.component';
@NgModule({
  declarations: [
    BaseHighchartComponent,
    BarsChartComponent,
    LineChartComponent,
    DonutChartComponent,
    SalesBreakdownComponent,
    StatisticsBreakdownComponent,
    AgentStatusTimeComponent,
    MessageTrafficComponent,
    BugReportComponent,
    HourlySalesComponent,
    HourlyCallsAndSalesComponent,
    NotificationsComponent,
    RequestsComponent,
    CallResolvedComponent,
    EfficiencyCallStatsComponent,
    CallSaleStatsHourlyComponent,
    PeakHourTrafficComponent,
    ConnectedCallStatisticsComponent,
    NotConnectedCallStatisticsComponent,
    AbandonedCallStatisticsComponent,
    AgentsViewComponent,
    TopDispositionsComponent,
    ChatVolumeComponent,
    ChatBreakdownComponent,
    ChatStatisticsComponent,
    ChatChannelStatsComponent,
    CampaignMonitorCallsComponent,
    AgentStatusTimeVerticalComponent,
    CampaignMonitorSalesComponent,
    SurveysComponent,
    ChannelTrackComponent,
    AverageChatComponent,
    AverageRatingComponent,
    ChatBreakdownV2Component,
    SmsBreakdownComponent,
    VocSentimentCountComponent,
    VocSentimentTrendComponent,
    VocCategorySummaryComponent,
    VocTrendingTopicsComponent,
    VocTrendingWordsComponent,
    VocCategoriesDisplayedOverTimeComponent,
    VocTopVisitedSitesComponent,
    VocTopRatedSitesComponent,
    VocRatingDistributionsTsComponent,
    VocReviewsComponent,
    LeadsCallStatisticsComponent,
    LeadStatusStatisticsComponent,
    LeadConversionRatioComponent,
    OutboundDialerComponent,
    CardAvgCallPickupRateComponent,
    UnContactedLeadsComponent,
    NumberOfLeadsDialedComponent,
    NumberOfContactImportComponent,
    OutboundCampaignProgressComponent,
    TopFiveFailConversionsComponent,
    SuccessCallRateComponent,
    ConversionFirstAttemptComponent,
    AgentDispositionsWithLeadsPerDayComponent,
    SaleByProviderComponent,
    LeadSummaryComponent,
    LeadsDialedMadeComponent,
    LeadsConnectedCallsComponent,
    LeadsEmailSendComponent,
    LeadsCadenceComponent,
    LeadsDispositionsComponent,
    StarlinkStatsComponent,
    StarlinkAgentLeadCountryWiseComponent,
    LeadsCountryWiseDistributionComponent,
    LeadsResolvedComponent,
    GaugeClockComponent,
    SkillWiseHourlyComponent,
    SkillWiseSummaryComponent,
    SkillWiseHourlyHeatMapComponent
  ],
  imports: [
    CommonModule,
    HighchartsChartModule,
    NgScrollbarModule,
    PasswordStrengthMeterModule.forRoot(),
    ToggleOptionsComponent,
    DropdownModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    BaseHighchartComponent,
    BarsChartComponent,
    LineChartComponent,
    DonutChartComponent,
    SalesBreakdownComponent,
    StatisticsBreakdownComponent,
    AgentStatusTimeComponent,
    MessageTrafficComponent,
    BugReportComponent,
    HourlySalesComponent,
    HourlyCallsAndSalesComponent,
    NotificationsComponent,
    RequestsComponent,
    CallResolvedComponent,
    EfficiencyCallStatsComponent,
    CallSaleStatsHourlyComponent,
    PeakHourTrafficComponent,
    ConnectedCallStatisticsComponent,
    NotConnectedCallStatisticsComponent,
    AbandonedCallStatisticsComponent,
    AgentsViewComponent,
    TopDispositionsComponent,
    ChatVolumeComponent,
    ChatBreakdownComponent,
    ChatStatisticsComponent,
    ChatChannelStatsComponent,
    PasswordStrengthMeterModule,
    CampaignMonitorCallsComponent,
    AgentStatusTimeVerticalComponent,
    CampaignMonitorSalesComponent,
    DropdownModule,
    SurveysComponent,
    ChannelTrackComponent,
    AverageChatComponent,
    AverageRatingComponent,
    ChatBreakdownV2Component,
    SmsBreakdownComponent,
    VocSentimentCountComponent,
    VocSentimentTrendComponent,
    VocCategorySummaryComponent,
    VocTrendingTopicsComponent,
    VocTrendingWordsComponent,
    VocCategoriesDisplayedOverTimeComponent,
    VocTopVisitedSitesComponent,
    VocTopRatedSitesComponent,
    VocRatingDistributionsTsComponent,
    VocReviewsComponent,
    LeadsCallStatisticsComponent,
    LeadStatusStatisticsComponent,
    LeadConversionRatioComponent,
    OutboundDialerComponent,
    CardAvgCallPickupRateComponent,
    UnContactedLeadsComponent,
    NumberOfLeadsDialedComponent,
    NumberOfContactImportComponent,
    OutboundCampaignProgressComponent,
    TopFiveFailConversionsComponent,
    SuccessCallRateComponent,
    ConversionFirstAttemptComponent,
    AgentDispositionsWithLeadsPerDayComponent,
    SaleByProviderComponent,
    LeadSummaryComponent,
    LeadsDialedMadeComponent,
    LeadsConnectedCallsComponent,
    LeadsEmailSendComponent,
    LeadsCadenceComponent,
    LeadsDispositionsComponent,
    StarlinkStatsComponent,
    StarlinkAgentLeadCountryWiseComponent,
    LeadsCountryWiseDistributionComponent,
    LeadsResolvedComponent,
    ToggleOptionsComponent,
    GaugeClockComponent,
    SkillWiseHourlyComponent,
    SkillWiseSummaryComponent,
    SkillWiseHourlyHeatMapComponent
  ],
})
export class WidgetsModule {}
